import { WidthContainer } from '@pata-app/ui-document';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { CallToActionButtons } from '../../../../components/callToActionButtons/callToActionButtons';
import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { SIGN_UP_PROCESS_CONFIG } from './signUpProcess.config';
import {
  ProcessesContainer,
  ProcessDot,
  ProcessItem,
  SignUpProcessContainer,
  SignUpProcessContent,
  SignUpProcessTitleContainer,
  ProcessContainer,
  ActionsContainer,
} from './signUpProcess.styled';

const { VITE_CDN_BASE_URL } = getEnv();

const SignUpProcessTitle = () => {
  return (
    <SignUpProcessTitleContainer>
      <h2>Enable online bookings for your pet business in just four steps</h2>
    </SignUpProcessTitleContainer>
  );
};
const SignUpProcessSubTitle = () => {
  return (
    <SignUpProcessTitleContainer>
      <p>
        Accept online bookings, reduce no-shows and make it easier for clients to book, all from one simple booking
        platform built for pet care professionals.
      </p>
    </SignUpProcessTitleContainer>
  );
};

export function SignUpProcess() {
  // const theme = useTheme();
  return (
    <SignUpProcessContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-phone-laptop-app.webp`}
        alt="Pata app on laptop and iPhone used to find and book pet care services"
        height={2000}
        width={2000}
      />
      <WidthContainer noBackground>
        <SectionContainer title={SignUpProcessTitle}>
          <SignUpProcessContent>
            <ProcessesContainer>
              {SIGN_UP_PROCESS_CONFIG.map((process) => (
                <ProcessItem key={process.title}>
                  {/* <ProcessDot /> */}
                  <ProcessContainer>
                    <strong>{process.number}.</strong>
                    <strong>{process.title}</strong>
                    <p>{process.description}</p>
                  </ProcessContainer>
                </ProcessItem>
              ))}
            </ProcessesContainer>

            <ActionsContainer>
              <CallToActionButtons />
            </ActionsContainer>
          </SignUpProcessContent>
        </SectionContainer>
      </WidthContainer>
    </SignUpProcessContainer>
  );
}
